import { FC, ReactElement } from 'react';
import styled from 'styled-components';
import colorVariables from '../../Globals/colors.module.css';
import fontVariables from '../../Globals/fonts.module.css';
import { ImageSwitch } from 'components/imageSwitch';

const MainComponent: FC<MicroFrontendProps> = ({
  tenant,
  colorMode,
  properties,
}): ReactElement => {
  const globalClasses = [
    colorVariables.globalColors,
    fontVariables.globalFonts,
    colorMode === 'dark' ? colorVariables.globalColorsDark : '',
  ];
  const defaultProperties = {
    labelType: 'top',
    mobileImageUrl: '',
    tabletImageUrl: '',
    desktopImageUrl: '',
    mobileImageUrlDark: '',
    tabletImageUrlDark: '',
    desktopImageUrlDark: '',
    title: '',
    lead: '',
    width: 'textextendedfullmobile',
    caption: '',
    source: '',
    mobileAnnotations: '',
    tabletAnnotations: '',
    desktopAnnotations: '',
    hideOnMobile: false,
    hideOnDesktop: false,
  };
  const { mobileImageUrl,
    tabletImageUrl,
    desktopImageUrl,
    mobileImageUrlDark,
    tabletImageUrlDark,
    desktopImageUrlDark,
    title,
    lead,
    width,
    caption,
    source,
    labelType,
    mobileAnnotations,
    tabletAnnotations,
    desktopAnnotations,
    hideOnMobile,
    hideOnDesktop,
  } = {
    ...defaultProperties,
    ...properties,
  };

  return (
    <AppContainer 
      className={globalClasses.join(' ')}
      hideOnMobile={hideOnMobile}
      hideOnDesktop={hideOnDesktop}
    >
      <ImageSwitch
        colorMode={colorMode}
        mobileImageUrl={mobileImageUrl}
        tabletImageUrl={tabletImageUrl}
        desktopImageUrl={desktopImageUrl}
        mobileImageUrlDark={mobileImageUrlDark}
        tabletImageUrlDark={tabletImageUrlDark}
        desktopImageUrlDark={desktopImageUrlDark}
        title={title}
        lead={lead}
        width={width as 'text' | 'article' | 'content' | 'full' | 'textextended' | 'textextendedfullmobile'}
        caption={caption}
        source={source}
        labelType={labelType as 'top' | 'bottom'}
        mobileAnnotations={mobileAnnotations}
        tabletAnnotations={tabletAnnotations}
        desktopAnnotations={desktopAnnotations}
      ></ImageSwitch>
    </AppContainer>
  );
};
const AppContainer = styled.div<{ 
  tenant?: string; 
  hideOnMobile?: any;
  hideOnDesktop?: any;
}>`
  width: 100%;
  max-width: 100%;
  overflow: hidden;
  margin: 0;
  padding: 0;
  margin-bottom: 30px;
  font-family: var(--font-plex);
  color: var(--brandblue-main);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  /* Hide on mobile when hideOnMobile is set to any truthy value */
  ${({ hideOnMobile }) => hideOnMobile && `
    @media (max-width: 767px) {
      display: none;
    }
  `}

  /* Hide on desktop when hideOnDesktop is set to any truthy value */
  ${({ hideOnDesktop }) => hideOnDesktop && `
    @media (min-width: 768px) {
      display: none;
    }
  `}

  code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
      monospace;
  }
`;
export default MainComponent;
